import { NavLink, useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import locContext from "../context/locContext";
// import 'animate.css';

function Navbar() {
  const { location, data, getAddtoCartData } = useContext(locContext);
  const userRoll = JSON.parse(localStorage.getItem("adminRoll"));

  const [isToggled, setIsToggled] = useState(false);
  const navigate = useNavigate(); // Use navigate to programmatically navigate


  const titles = [
    { name: 'enquire', pageid: 'enquire-fom', page: '' },

    { name: 'About Our Founder Nupur Shah Founder of AerialBelly', pageid: 'nupur-shah', page: 'about' },
    { name: 'About AerialBelly', pageid: 'about-aerialBelly', page: 'about' },
    { name: 'AerialBelly Studio', pageid: 'aerialBelly-studio', page: 'about' },
    { name: 'OUR PROFESSIONAL INSTRUCTORS', pageid: 'ourprofessional', page: 'about' },

    { name: 'In-Studio Classes / Online Classes', pageid: 'instudio-clas', page: 'bellydance' },
    { name: 'Learn Authentic Belly Dance With Us', pageid: 'authentic-bellydance', page: 'bellydance' },
    { name: 'Fee Structure Of Group Belly Dance Classes (In Studio & Online Classes)', pageid: 'group-bellydance-fee', page: 'bellydance' },
    { name: 'Belly Dance Classes at AerialBelly Studio', pageid: 'bellydance-schedule', page: 'bellydance' },
    { name: 'Belly Dance Private Classes With Our Senior Instructor', pageid: 'bellydance-private-instructor', page: 'bellydance' },
    { name: 'Belly Dance Private Classes With Nupur Shah', pageid: 'bellydance-private-nupurshah', page: 'bellydance' },
    { name: 'Fusion Belly Dance Classes', pageid: 'fusion-belly-dance', page: 'bellydance' },
    { name: 'Monthly Bolly Belly Choreography Classes', pageid: 'bolly-belly-classes', page: 'bellydance' },
    { name: 'Monthly Indo Belly Choreography Classes', pageid: 'ibdo-belly-classes', page: 'bellydance' },
    { name: 'Monthly Sufi Belly Dance Classes', pageid: 'sufi-belly-classes', page: 'bellydance' },
    { name: 'Monthly Lock Pop Belly Dance Classes', pageid: 'lockpop-belly-classes', page: 'bellydance' },
    { name: 'Drum Solo Belly Dance Classes', pageid: 'drumsolo-belly-classes', page: 'bellydance' },

    { name: 'About Aerial Arts Classes', pageid: 'aerial-arts-classes', page: 'aerialbellyart' },
    { name: 'Aerial Silk Classes', pageid: 'aerial-silk-classes', page: 'aerialbellyart' },
    { name: 'Aerial Yoga Classes', pageid: 'aerial-yoga-classes', page: 'aerialbellyart' },
    { name: 'Aerial Hammock Classes', pageid: 'aerial-hammock-classes', page: 'aerialbellyart' },
    { name: 'Aerial Hoop / Lyra Classes', pageid: 'aerial-hoop-classes', page: 'aerialbellyart' },
    { name: 'Aerial Trapeze Classes', pageid: 'aerial-trapeze-classes', page: 'aerialbellyart' },
    { name: 'Aerial Cube Classes', pageid: 'aerial-cube-classes', page: 'aerialbellyart' },
    { name: 'Aerial Toddler Classes', pageid: 'aerial-toddler-classes', page: 'aerialbellyart' },
    { name: 'Aerial Arts Combo Classes', pageid: 'aerial-combo-classes', page: 'aerialbellyart' },
    { name: 'Aerial Arts Classes at AerialBelly Studio', pageid: 'aerial-art-schedule', page: 'aerialbellyart' },

    { name: 'Crash Course / Events / Workshop', pageid: '', page: 'bellydanceworkshop' },

    { name: 'STUDIO RENTAL & COLLABORATION', pageid: 'studio-rental', page: 'studiorental' },

    { name: 'Our Annual Show', pageid: 'annual-show', page: 'omi' },

    { name: 'AerialBelly Live Shows Our Live Shows, Events And Workshops Worldwide', pageid: 'live-shows', page: 'ourliveshow' },

    { name: 'Our Annual Membership', pageid: 'anuual-membership', page: 'annualmember' },

    { name: 'Terms & Conditions', pageid: 'terms-conditions', page: 'terms-&-conditions' },

    { name: 'Shop product', pageid: '', page: 'shop' },

    { name: 'Order List', pageid: '', page: 'orderlist' },

    { name: 'Invoice', pageid: '', page: 'invoice' },

    { name: 'Profile', pageid: '', page: 'profile' },

    { name: 'Achievement', pageid: '', page: 'achievement' },

    { name: 'Payment History', pageid: '', page: 'payment-history' },

    { name: 'How to Register registration login', pageid: 'make-purchases', page: 'faqs' },
    { name: 'How to make the purchase How to book classes or workshops How to purchase how to make payment Cash Payment cash purchase make purchase book classes', pageid: 'make-payment', page: 'faqs' },
  ]


  const [searchQuery, setSearchQuery] = useState('');

  const [alert, setAlert] = useState(false);
  const handleSearch = () => {
    const query = searchQuery.trim().toLowerCase();
    if (query) {
      const foundTitle = titles.find((title) => title.name.toLowerCase().includes(query));
      if (foundTitle) {
        navigate(`/${foundTitle.page}#${foundTitle.pageid}`);
        setSearchQuery("");

        // Scroll to the section after navigating
        setTimeout(() => {
          const section = document.getElementById(foundTitle.pageid);
          if (section) {
            section.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 500); // Delay to allow page navigation
      } else {
        setAlert(true);
        setSearchQuery("");

        setTimeout(() => {
          setAlert(false);
        }, 2800);
      }
    }
  };

  useEffect(() => {
    // Auto-scroll to the section when page loads with a hash
    const hash = window.location.hash.replace("#", ""); // Get the hash without #
    if (hash) {
      setTimeout(() => {
        const section = document.getElementById(hash);
        if (section) {
          section.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 500); // Delay to allow rendering
    }
  }, []);

  const [searchToggled, setSearchToggled] = useState(false);
  const searchToggle = () => {
    setSearchToggled((prev) => !prev); // Toggle state correctly
  };

  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  const handleLogout = async () => {
    Swal.fire({
      title: "Logout",
      text: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(`${process.env.REACT_APP_BACKEND_BASE_URL}/logout`)
          .then((res) => {
            if (res.data.Status === "Success") {
              document.cookie =
                "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
              localStorage.removeItem("adminRoll");
              localStorage.removeItem("aerialst");
              navigate("/");

              Swal.fire({
                icon: "success",
                title: "User Logout",
                timer: 1500,
              });
            } else {
              alert("Error");
            }
          })
          .catch((err) => console.log(err));
      }
    });
  };

  useEffect(() => {
    getAddtoCartData();
  }, []);

  return (
    <>
      {alert ? <div className="alertt animate__animated animate__backInDown">
        <div className="alerttext">
          <p><i className="fa-solid fa-circle-xmark"></i>&nbsp;&nbsp; No results found</p>
        </div>
      </div> : ''}



      {(userRoll === null || userRoll === "student") && (
        <>
          <a href="https://api.whatsapp.com/send?phone=918487990530&amp;text=Hello" target="blank">
            <div className="whatapp">
              <i className="fa-brands fa-whatsapp fa-2xl"></i>
            </div>
          </a>
          <div className="search-box">
            <button className={`btn-search ${searchToggled ? 'btn-search-open' : ''}`}
              onClick={() => {
                searchToggle();
                handleSearch();
              }}
            >
              <i className="fas fa-search"></i>
            </button>
            <input
              type="text"
              className={`input-search ${searchToggled ? 'input-search-open' : ''}`}
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} />
          </div>
          {!userRoll ? ''
            :
            <>
              <NavLink to={'/addtocard'}
                onClick={() =>
                  window.scrollTo({ top: 0, behavior: "instant" })
                }>
                <div className="cart-fix">
                  <i className="fa-solid fa-cart-shopping"></i>
                  <div className="cart-count">{data.length}</div>
                </div>
              </NavLink>
            </>
          }
          <div
            className={
              isToggled
                ? "sidemenu-wrapper show style2 d-lg-block"
                : "sidemenu-wrapper style2 d-lg-block"
            }
          >
            <div className="sidemenu-content bgringggg2">
              <button
                className="closeButton sideMenuCls"
                onClick={() => setIsToggled(false)}
              >
                <i className="far fa-times"></i>
              </button>
              <div className="about-logo" style={{ marginTop: "40px" }}>
                <NavLink
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "instant" })
                  }
                  to={"/"}
                >
                  <img
                    src="/assets/img/Aerial_Belly_Final_Logo.png"
                    alt="Aerial Belly"
                  />
                </NavLink>
              </div>
              <div className="widget mt-5">
                <div className="recent-post-wrap">
                  <div className="recent-post style2">
                    <ul>
                      <li className="navpho" onClick={() => setIsToggled(false)}>
                        <NavLink
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "instant" })
                          }
                          to={"/about"}
                        >
                          About Us
                        </NavLink>
                      </li>
                      <li className="navpho" onClick={() => setIsToggled(false)}>
                        <NavLink
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "instant" })
                          }
                          to={"/bellydance"}
                        >
                          Belly Dance Classes
                        </NavLink>
                      </li>
                      <li className="navpho" onClick={() => setIsToggled(false)}>
                        <NavLink
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "instant" })
                          }
                          to={"/aerialbellyart"}
                        >
                          Aerial Arts Classes
                        </NavLink>
                      </li>
                      <li className="navpho" onClick={() => setIsToggled(false)}>
                        <NavLink
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "instant" })
                          }
                          to={"/bellydanceworkshop"}
                        >
                          {/* Belly Dance Workshop / Event */}
                          Crash Course / Events /  Workshop
                        </NavLink>
                      </li>
                      <li className="navpho" onClick={() => setIsToggled(false)}>
                        <NavLink
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "instant" })
                          }
                          to={"/prerecordingclasses"}
                        >
                          Pre Recorded Classes
                        </NavLink>
                      </li>
                      <li className="navpho" onClick={() => setIsToggled(false)}>
                        <NavLink
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "instant" })
                          }
                          to={"/addtocard"}
                        >
                          My Cart
                        </NavLink>
                      </li>

                      <li onClick={() => setIsToggled(false)}>
                        <NavLink
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "instant" })
                          }
                          to={"/studiorental"}
                        >
                          Studio Rental And Collaboration
                        </NavLink>
                      </li>

                      <li onClick={() => setIsToggled(false)}>
                        <NavLink
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "instant" })
                          }
                          to={"/omi"}
                        >
                          OMI - Our Annual Show
                        </NavLink>
                      </li>

                      <li onClick={() => setIsToggled(false)}>
                        <NavLink
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "instant" })
                          }
                          to={"/ourliveshow"}
                        >
                          Live Shows
                        </NavLink>
                      </li>

                      <li onClick={() => setIsToggled(false)}>
                        <NavLink
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "instant" })
                          }
                          to={"/annualmember"}
                        >
                          Annual Membership
                        </NavLink>
                      </li>
                      <li onClick={() => setIsToggled(false)}>
                        <NavLink
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "instant" })
                          }
                          to={"/packages"}
                        >
                          Packages & Discounts
                        </NavLink>
                      </li>
                      <li onClick={() => setIsToggled(false)}>
                        <NavLink
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "instant" })
                          }
                          to={"/terms-&-conditions"}
                        >
                          Terms  & Conditions
                        </NavLink>
                      </li>
                      {location === 'IN'
                        ? <li onClick={() => setIsToggled(false)}>
                          <NavLink
                            onClick={() =>
                              window.scrollTo({ top: 0, behavior: "instant" })
                            }
                            to={"/shop"}
                          >
                            Shop
                          </NavLink>
                        </li>
                        : ''}
                      <li onClick={() => setIsToggled(false)}>
                        <NavLink
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "instant" })
                          }
                          to={"/faqs"}
                        >
                          FAQs
                        </NavLink>
                      </li>
                      {userRoll ? (
                        <li onClick={() => setIsToggled(false)}>
                          <li
                            onClick={() => setIsToggled(false)}
                            className="mt-5"
                          >
                            <NavLink
                              onClick={() =>
                                window.scrollTo({ top: 0, behavior: "instant" })
                              }
                              to={"/orderlist"}
                            >
                              My Orders
                            </NavLink>
                          </li>
                          <li onClick={() => setIsToggled(false)}>
                            <NavLink
                              onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                              to={"/your-library"}>
                              Your Library
                            </NavLink>
                          </li>
                          <li onClick={() => setIsToggled(false)}>
                            <NavLink
                              onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                              to={"/invoice"}>
                              Invoice
                            </NavLink>
                          </li>
                          <li
                            onClick={() => setIsToggled(false)}
                          >
                            <NavLink
                              onClick={() =>
                                window.scrollTo({ top: 0, behavior: "instant" })
                              }
                              to={"/profile"}
                            >
                              Profile
                            </NavLink>
                          </li>
                          <li
                            onClick={() => setIsToggled(false)}
                          >
                            <NavLink
                              onClick={() =>
                                window.scrollTo({ top: 0, behavior: "instant" })
                              }
                              to={"/achievement"}
                            >
                              Achievement
                            </NavLink>
                          </li>
                          <li onClick={() => setIsToggled(false)}                          >
                            <NavLink
                              onClick={() =>
                                window.scrollTo({ top: 0, behavior: "instant" })
                              }
                              to={"/payment-history"}
                            >
                              Payment History
                            </NavLink>
                          </li>
                          <NavLink
                            onClick={handleLogout}
                            style={{ fontWeight: 650, color: "black" }}
                          >
                            Logout
                          </NavLink>
                        </li>
                      ) : (
                        <li onClick={() => setIsToggled(false)}>
                          <NavLink to={"/loginpage"}>Login / Registration</NavLink>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="widget">
                <div className="th-widget-about">
                  <div className="th-social style2">
                    <NavLink to={"https://www.facebook.com/share/9XT9SNsX2vaAyTLk/?mibextid=LQQJ4d"} target="blank">
                      <i className="fab fa-facebook-f"></i>
                    </NavLink>
                    <NavLink to={"https://www.instagram.com/aerialbelly?igsh=MnNrYmdjYnpmY2w1"} target="blank">
                      <i className="fa-brands fa-instagram"></i>
                    </NavLink>
                    <NavLink to={"https://youtube.com/@nupurshahh?si=77KsUw4I3NB4rya0"} target="blank">
                      <i className="fa-brands fa-youtube"></i>
                    </NavLink>
                    <NavLink to={"https://g.co/kgs/5HqUQBb"} target="blank">
                      <i className="fa-brands fa-google"></i>
                    </NavLink>
                    <NavLink to={"mailto:aerialbelly@gmail.com"} target="blank">
                      <i className="fa-solid fa-envelope"></i>
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <header className="th-header header-layout2">
            <div className="sticky-wrapper">
              <div className="menu-area">
                <div className="container menu-ipad">
                  <div className="row align-items-center justify-content-between bgring2">
                    <div className="col-auto">
                      <div className="header-logo">
                        <NavLink
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "instant" })
                          }
                          to={"/"}
                        >
                          <img
                            src="/assets/img/Aerial_Belly_Final_Logo.png"
                            alt="Aerial Belly"
                          />
                        </NavLink>
                      </div>
                    </div>
                    <div className="col-auto">
                      <nav className="main-menu d-none d-lg-inline-block">
                        <ul>
                          <li>
                            <NavLink
                              onClick={() =>
                                window.scrollTo({ top: 0, behavior: "instant" })
                              }
                              to={"/about"}
                            >
                              About Us
                            </NavLink>
                          </li>
                          <li className="menu-item-has-children">
                            <NavLink
                              onClick={() =>
                                window.scrollTo({ top: 0, behavior: "instant" })
                              }
                              to={"/bellydance"}
                            >
                              Our courses
                            </NavLink>
                            <ul className="sub-menu">
                              <li>
                                <NavLink
                                  onClick={() =>
                                    window.scrollTo({
                                      top: 0,
                                      behavior: "instant",
                                    })
                                  }
                                  to={"/bellydance"}
                                >
                                  Belly Dance Classes
                                </NavLink>
                              </li>
                              <li>
                                <NavLink
                                  onClick={() =>
                                    window.scrollTo({
                                      top: 0,
                                      behavior: "instant",
                                    })
                                  }
                                  to={"/aerialbellyart"}
                                >
                                  Aerial Arts Classes
                                </NavLink>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <NavLink
                              onClick={() =>
                                window.scrollTo({ top: 0, behavior: "instant" })
                              }
                              to={"/bellydanceworkshop"}
                            >
                              Crash Course / Events /  Workshop
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              onClick={() =>
                                window.scrollTo({ top: 0, behavior: "instant" })
                              }
                              to={"/prerecordingclasses"}
                            >
                              Pre-Recorded Classes
                            </NavLink>
                          </li>
                        </ul>
                      </nav>
                    </div>
                    <button
                      type="button"
                      onClick={handleToggle}
                      className="th-menu-toggle"
                    >
                      <i className="far fa-bars"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="logo-bg"></div>
              <div className="menu-bg"></div>
            </div>
          </header>
        </>
      )}

      {userRoll === "admin" && (
        <>
          <div className="header">
            <div className="header-left">
              <NavLink
                onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                to={"/"}
                className="logo"
              >
                <img
                  src="/assets/img/Aerial_Belly_Final_Logo.png"
                  alt="Aerial Belly"
                />
              </NavLink>
            </div>
            <div
              onClick={handleToggle}
              className={isToggled ? "navbartog mobile_btn" : "mobile_btn"}
            >
              <i className="fas fa-align-left"></i>
            </div>
            <div className="header-split" style={{ pointerEvents: 'none' }}>
              <div className="page-headers">
                <div className="search-bar">
                  <span>
                    <i className="fe fe-search"></i>
                  </span>
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control"
                  />
                </div>
              </div>
              <ul className="nav user-menu mt-4" style={{ pointerEvents: 'initial' }}>
                <li className="nav-item dropdown logout-box">
                  <div className="user-NavLink  nav-NavLink">
                    <span className="user-img" onClick={handleLogout}>
                      <i
                        className="fa-solid fa-arrow-right-from-bracket"
                        style={{ color: "#26448c", fontSize: "20px" }}
                      ></i>
                      <span className="animate-circle"></span>
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* <!-- Sidebar --> */}
          <div
            onClick={handleToggle}
            className={isToggled ? "navbartog sidebar" : "sidebar"}
            id="sidebar"
          >
            <div className="sidebar-header">
              <NavLink
                onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                to={"/student"}
              >
                <div className="sidebar-logo">
                  <NavLink
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: "instant" })
                    }
                    to={"/student"}
                  >
                    <img
                      src="/assets/img/Aerial_Belly_Final_Logo.png"
                      className="img-fluid logo"
                      alt="Aerial Belly"
                    />
                  </NavLink>
                  <NavLink
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: "instant" })
                    }
                    to={"/student"}
                  >
                    <img
                      src="/assets/img/Aerial_Belly_Final_Logo.png"
                      className="img-fluid logo-small"
                      alt="Aerial Belly"
                    />
                  </NavLink>
                </div>
              </NavLink>
            </div>

            <div className="sidebar-inner slimscroll">
              <div id="sidebar-menu" className="sidebar-menu">
                <ul>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/student"}
                    >
                      <i className="fa-solid fa-user"></i>
                      <span>Customer</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/workshop"}
                    >
                      <i className="fa-solid fa-book"></i>
                      <span>Workshop / Event</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/brand"}
                    >
                      <i className="fa-solid fa-ring"></i>
                      <span>Brand Logo</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/aerialartsimg"}
                    >
                      <i className="fa-solid fa-image"></i>
                      <span>Aerial Arts Images</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/omiimg"}
                    >
                      <i className="fa-solid fa-image"></i>
                      <span>Omi Images</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/product"}
                    >
                      <i className="fa-solid fa-bag-shopping"></i>
                      <span>Product</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/addons"}
                    >
                     <i class="fa-solid fa-basket-shopping"></i>
                      <span>AddOns</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/pre-recording"}
                    >
                      <i class="fa-solid fa-photo-film"></i>
                      <span>Pre Recorded Classes</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/profilecard"}
                    >
                      <i className="fa-regular fa-id-card"></i>
                      <span>Profile Card</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/timetable"}
                    >
                      <i className="fa-regular fa-hourglass-half"></i>
                      <span>Aerial Arts Classes Timetable</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/bellydancetimetable"}
                    >
                      <i className="fa-regular fa-hourglass-half"></i>
                      <span>Belly Dance Classes Timetable</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/tableamount"}
                    >
                      <i className="fa-solid fa-money-bill-wave"></i>
                      <span>Pricing</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/certificate"}
                    >
                      <i className="fa-solid fa-trophy"></i>
                      <span>Certificate</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/latefee"}
                    >
                      <i className="fa-solid fa-book"></i>
                      <span>Late Fee Payment Penalty</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/result"}
                    >
                      <i className="fa-solid fa-paste"></i>
                      <span>Result</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/reminder"}
                    >
                      <i className="fa-solid fa-stopwatch"></i>
                      <span>Reminder</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/notification"}
                    >
                      <i className="fa-solid fa-bell"></i>
                      <span>Notification</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/couponcode"}
                    >
                      <i className="fa-solid fa-receipt"></i>
                      <span>Coupon Code</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/goldenline"}
                    >
                      <i className="fa-solid fa-bullhorn"></i>
                      <span>Home Announcement</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/all-payment-history"}
                    >
                      <i className="fa-solid fa-money-check-dollar"></i>
                      <span>Payment History</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/pending-cash"}
                    >
                      <i className="fa-solid fa-sack-dollar"></i>
                      <span>Pending Cash</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/studio-rental-confirmation"}
                    >
                      <i className="fa-solid fa-building"></i>
                      <span>Studio Rental Confirmation</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/planpurchase"}
                    >
                      <i className="fa-solid fa-book"></i>
                      <span>Course Purchase</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/purchasepackages"}
                    >
                      <i className="fa-solid fa-book"></i>
                      <span>Workshop & Product Purchases</span>
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </>
      )}
      <style jsx>{`
  @media (min-width: 1000px) and (max-width: 1450px) { 
  
    .container.menu-ipad {
      margin: 0;
      max-width: 100%;
    }
    .main-menu>ul>li {
      margin: 0 10px;
    }
    .header-layout2 .main-menu {
      margin-left: 0;
    }
    .bgring2::after {
      left: 20px;
    }

  }    
      `}</style>
    </>
  );
}

export default Navbar;
